import { makeStyles } from '@rbx/ui';

const useStreamingIndicatorStyles = makeStyles()((theme) => ({
  container: {
    opacity: 0.5,
  },

  dot: {
    width: 4,
    height: 4,
    borderRadius: '50%',
    marginRight: 2,
    display: 'inline-block',
    backgroundColor: theme.palette.content.muted,
  },
}));

export default useStreamingIndicatorStyles;
